// Client frontend pour les endpoints IA (OpenAI) — backend/src/routes/ai.js

const BASE = "https://support.gs-group.fr/api";
const tok = () => localStorage.getItem("nexo_token");
const h = () => ({ Authorization: "Bearer " + tok(), "Content-Type": "application/json" });

/** @param {string} notes @param {string} [contexte] @returns {Promise<string>} */
async function synthese(notes, contexte) {
  const r = await fetch(`${BASE}/ai/synthese-rapport`, {
    method: "POST", headers: h(), body: JSON.stringify({ notes, contexte }),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d.synthese || "";
}

/**
 * @param {string} texte
 * @param {Array<{id:number|string, designation:string, reference?:string}>} produits
 * @returns {Promise<Array<{produit_id:number|string, quantite:number}>>}
 */
async function parseMateriel(texte, produits) {
  const r = await fetch(`${BASE}/ai/parse-materiel`, {
    method: "POST", headers: h(), body: JSON.stringify({ texte, produits }),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return Array.isArray(d.items) ? d.items : [];
}

/** @returns {Promise<{hasOpenaiKey:boolean, hasAnthropicKey:boolean, source:string, updatedAt:string|null}>} */
async function getConfig() {
  return fetch(`${BASE}/ai/config`, { headers: h() }).then(r => r.json());
}

/** @param {{openaiKey?:string, anthropicKey?:string}} cfg clé omise/vide → conserve la clé déjà enregistrée */
async function saveConfig(cfg) {
  const r = await fetch(`${BASE}/ai/config`, { method: "POST", headers: h(), body: JSON.stringify(cfg) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** @param {{openaiKey?:string, anthropicKey?:string}} cfg */
async function testConfig(cfg) {
  const r = await fetch(`${BASE}/ai/config/test`, { method: "POST", headers: h(), body: JSON.stringify(cfg) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/**
 * @param {Array<{role:string, content:string}>} messages historique de conversation (sans system prompt, géré côté serveur)
 * @returns {Promise<{reply:string, toolsUsed:string[]}>}
 */
async function chat(messages) {
  const r = await fetch(`${BASE}/ai/chat`, { method: "POST", headers: h(), body: JSON.stringify({ messages }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** @param {string} message @param {string} [context] @returns {Promise<string[]>} */
async function suggestEmail(message, context) {
  const r = await fetch(`${BASE}/ai/suggest-email`, { method: "POST", headers: h(), body: JSON.stringify({ message, context }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return Array.isArray(d.suggestions) ? d.suggestions : [];
}

/** @returns {Promise<{resume:string, stats:{reussies:number, non_resolues:number, planifiees_jour:number, en_retard_trafic:number}}>} */
async function dashboardSummary() {
  const r = await fetch(`${BASE}/ai/dashboard-summary`, { headers: h() });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

export const aiApi = { synthese, parseMateriel, getConfig, saveConfig, testConfig, chat, suggestEmail, dashboardSummary };
